<template>
  <div
    @click="openStudentAssessment"
    class="bg-gray-100 rounded-b relative h-56"
    :class="[user_speaker || on_queue ? '' : 'rounded-t']"
  >
    <div v-if="currentTurn.id" class="absolute left-0 bottom-0 top-0 right-0 z-20 w-full h-full">
      <div class="relative w-full h-full">
        <div class="flex flex-col space-y-2 h-full">
          <div v-if="currentTurn.queue_position === 0" class="bg-gray-900 bg-opacity-50 backdrop-blur-lg font-poppins text-xs py-0.5 text-white text-center">
            Speaker
          </div>
          <div v-if="currentTurn.queue_position > 0 && currentTurn.queue_position < 999998" class="bg-gray-600 bg-opacity-50 backdrop-blur-lg font-poppins text-xs py-0.5 text-white text-center">
            Queue #{{ queueIndex }}
          </div>
          <div class="flex flex-col px-2 space-y-1">
            <div class="flex justify-between items-center" :class="{'pt-2':currentTurn.queue_position === 999999}">
              <div @click.stop="handleOpenDetailsTurn()" @mouseenter="is_hovering_turn = true" @mouseleave="is_hovering_turn = false" class="rounded-tr-full rounded-br-full rounded-tl-full cursor-pointer flex items-center space-x-2 px-3 py-1" :class="[generateTurnPhrases(currentTurn.turn_type).backgroundColor, turn_description ? 'cursor-pointer' : '']">
                <div v-html="determineTurnTypeIconHTML(currentTurn.turn_type)"></div>
                <span class="text-white text-xs font-poppins font-medium">{{ generateTurnPhrases(currentTurn.turn_type).title }}</span>
              </div>
              <div v-if="speaking_participants[participation.user.id]">
                <VolumeIndicator/>
              </div>
            </div>
            <div v-if="(is_hovering_turn === true && turn_description !== null) || is_turn_opened === true" class="bg-opacity-60 px-3 py-1 text-xs mt-1 rounded-tr-lg rounded-br rounded-bl text-white" :class="[generateTurnPhrases(currentTurn.turn_type).backgroundColor, turn_description ? 'cursor-pointer' : '']">
              {{ turn_description }}
            </div>
          </div>
          <div @mouseenter="activeMoreOptions = true" @mouseleave="activeMoreOptions = false" class="flex-grow px-2 h-full">
            <div class="flex flex-col h-full justify-end">
              <div v-if="activeMoreOptions" class="flex justify-between items-center space-x-2">
                <div v-if="hasTeacherPermissionsInCourse || user_is_moderator">
                  <button v-if="user_speaker" @click.stop="removeSpeaker(participation.user.id)" :disabled="loading_queue" class="sample px-3.5 disabled:opacity-50 py-2 flex items-center justify-center space-x-2 rounded-full bg-red-500 text-white">
                    <i class="fa-solid fa-flag-checkered"></i>
                    <span>End Turn</span>
                  </button>
                  <button v-else-if="on_queue" @click.stop="leaveQueue(participation.user.id, currentTurn.id)" :disabled="loading_queue" class="sample px-3.5 py-2 disabled:opacity-50 flex items-center justify-center space-x-2 rounded-full bg-white shadow hover:bg-gray-100 text-blueGray-800">
                    <i class="fa-solid fa-user-minus"></i>
                    <span>Remove</span>
                  </button>
                  <button v-else @click.stop="addToQueue(currentTurn.id)" :disabled="loading_queue" class="sample px-4 py-2 flex items-center justify-center space-x-2 rounded-full bg-white hover:bg-gray-100 shadow text-blueGray-800">
                    <div v-if="!currentSpeaker.id && !on_queue">
                      <i class="fa-solid fa-bullhorn"></i>
                      <span>Make Speaker</span>
                    </div>
                    <div v-else>
                      <i class="fa-solid fa-user-plus"></i>
                      <span>Add to Queue</span>
                    </div>
                  </button>
                </div>
                <div class="flex items-center space-x-2">
                  <button v-if="currentTurn.id && !user_speaker && hasTeacherPermissionsInCourse" :disabled="isTappingOut" @click.stop="teacherRemoveStudentFromCircle(participation.user.id)" class="sample px-4 disabled:opacity-50 py-2.5 flex items-center justify-center space-x-2 rounded-full bg-red-500 text-white">
                    <i class="fa-solid fa-arrow-up-from-bracket rotate-270"></i>
                  </button>
                  <button v-if="user_speaker && !is_my_participation" @click.stop="addToApplauseArray" :disabled="is_my_participation" class="sample px-2.5 py-1.5 flex items-center justify-center space-x-2 rounded-full shadow bg-white bg-opacity-90">
                    🙌
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="pb-2 px-2">
            <div class="flex w-full justify-between items-center overflow-x-hidden">
              <div class="flex items-center space-x-1">
                <button @click.stop="muteStudentParticipation(participation)" v-if="currentTurn.id && audio_video_is_active && joinedAudioDiscussion && student_joined_LD && !is_my_participation && (user_is_moderator || hasTeacherPermissionsInCourse)" class="flex space-x-1.5 bg-gray-800 text-white hover:bg-white shadow h-7 hover:text-blueGray-800 bg-opacity-50 rounded-full px-2.5 py-1.5 items-center">
                  <i class="fa-solid text-xs" :class="[participation.audio_is_enabled ? 'fa-microphone' : 'fa-microphone-slash']"></i>
                </button>
                <div class="flex space-x-0.5 bg-gray-800 bg-opacity-50 cursor-default rounded-full px-3 h-7 py-1 items-center">
                  
                  <span v-if="is_my_participation" class="text-white text-xs">You</span>
                  <div v-else :title="participation.user.name" class="text-white cursor-default text-xs max-width-name truncate">
                    <span>{{ first_name }}</span>
                  </div>
                  <i v-if="user_moderator_icon" class="fa-solid text-xs text-white fa-gavel ml-0.5"></i>
                </div>
              </div>
              <div class="flex items-center space-x-1.5">
                <button @click.stop="encourageStudent()" v-if="currentTurn.id && !user_speaker && currentTurn.turn_type !== 'video_audio_on'" :disabled="is_my_participation" :class="[is_my_participation ? 'cursor-default' : 'cursor-pointer',encourager_count ? 'bg-orange-700': 'bg-gray-800']" class="sample hover:bg-orange-700 h-7 flex items-center bg-opacity-50 rounded-full text-white space-x-1.5 px-2.5 py-1">
                  <i style="font-size: 12px;" class="fa-solid fa-ear-listen"></i>
                  <span>{{ encourager_count }}</span>
                </button>
                <div class="bg-gray-800 text-xs cursor-default flex items-center bg-opacity-50 rounded-full text-white space-x-1.5 h-7 px-2.5 py-1">
                  <i style="font-size: 10px;" class="fa-solid  fa-bullhorn text-xs"></i>
                  <span>{{ participation.turn_count }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="absolute" style="top: calc(50% - 30px); left: calc(50% - 35px)">
      <img
        :src="participation.user.avatar_url"
        class="rounded-full object-cover"
        style="width: 70px; height: 70px"
      />
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import find from 'lodash/find';
  import throttle from 'lodash/throttle';
  import confetti from 'canvas-confetti';
  import { EventBus } from 'utils/event-bus';
  import {
    updateTurn,
    removeStudentFromCircle,
  } from 'services/liveDiscussion/circle/circleServices.js';
  import toggleStudentParticipationAudio from 'services/liveDiscussion/toggleStudentParticipationAudio.js';
  import toggleStudentParticipationVideo from 'services/liveDiscussion/toggleStudentParticipationVideo.js';
  import VolumeIndicator from './volumeIndicator.vue';

  export default Vue.extend({
    data() {
      return {
        audio_video_is_active: false,
        speaking_participants: {},
        activeMoreOptions: false,
        openTurnDescription: false,
        is_button_queue_activate: true,
        is_hovering_turn: false,
        is_turn_opened: false,
        isTappingOut: false,
      };
    },
    components: {
      VolumeIndicator,
    },
    props: {
      queueIndex: {
        type: Number,
      },
      participationID: {
        type: String,
        default: '',
      },
      currentTurn: {
        type: Object,
        default() {
          return {};
        },
      },
      currentSpeaker: {
        type: Object,
        default() {
          return {};
        },
      },
      remoteUsers: {
        type: Array,
        default() {
          return [];
        },
      },
      joinedAudioDiscussion: {
        type: Boolean,
        default: false,
      },
      loading_queue: {
        type: Boolean,
        default: false,
      },
      isNotepadOpen: {
        type: Boolean,
        default: true,
      }
    },
    watch: {
      'getCurrentDiscussion.applause_turn'() {
        if (this.getCurrentDiscussion.applause_turn) {
          const { turnID, applauderID } =
            this.getCurrentDiscussion.applause_turn;
          if (turnID && applauderID) {
            if (
              turnID === this.currentTurn.id &&
              applauderID !== this.getProfile.id
            ) {
              this.showApplauseIcons();
            }
          }
        }
      },
      'getCurrentDiscussion.audio_discussion_is_enabled'() {
        this.audio_video_is_active =
          this.getCurrentDiscussion.audio_discussion_is_enabled;
      },
    },
    computed: {
      ...mapGetters([
        'getCurrentDiscussion',
        'getCourseDetail',
        'getProfile',
        'hasTeacherPermissionsInCourse',
        'getQueue',
      ]),
      user_is_moderator() {
        const user = this.getCurrentDiscussion.participations.find(
          (p) => p.user_id === this.getProfile.id
        );
        if (user && user.is_moderator) {
          return true;
        }
        return false;
      },
      user_moderator_icon() {
        const userModerator = this.getCurrentDiscussion.participations.find(
          (p) => p.id === this.participationID
        );
        if (userModerator && userModerator.is_moderator) {
          return true;
        }
        return false;
      },
      user_speaker() {
        if (
          this.participation &&
          this.participation.user_id &&
          this.currentSpeaker &&
          this.currentSpeaker.participation
        ) {
          return (
            this.currentSpeaker.participation.user.id ===
            this.participation.user.id
          );
        }
        return false;
      },
      is_my_participation() {
        return this.participation.user.id === this.getProfile.id;
      },
      participation() {
        const participation = this.getCurrentDiscussion.participations.find(
          (p) => p.id === this.participationID
        );
        return (
          participation || {
            id: '',
            turn_count: '',
            user: { id: '', avatar_url: '', name: '' },
          }
        );
      },
      turn_description() {
        return this.currentTurn.description;
      },
      list_of_encouragers() {
        const names = this.currentTurn.encouraged_by.map((e) => {
          const user = find(this.getCourseDetail.users, (u) => u.id === e);
          return user ? user.name.split(' ')[0] : null;
        });
        return names;
      },
      first_name() {
        return this.participation.user.name.split(' ')[0];
      },
      encourager_count() {
        return (
          (this.currentTurn &&
            this.currentTurn.encouraged_by &&
            this.currentTurn.encouraged_by.length) ||
          0
        );
      },
      encouraged_by_tooltip_content() {
        if(this.is_my_participation) return;
        const encouragedByCount = this.currentTurn.encouraged_by.length;
        const hearFromPhrase =
          encouragedByCount === 1
            ? ' person wants to hear from '
            : ' people want to hear from ';
        const encouragerNames = '(' + this.list_of_encouragers.join(', ') + ')';
        const content = encouragedByCount
          ? this.currentTurn.encouraged_by.length +
            hearFromPhrase +
            this.first_name +
            '<br />' +
            encouragerNames
          : `Want to hear ${this.first_name} speak?`;
        return { content };
      },
      student_joined_LD() {
        if (this.is_my_participation) {
          return this.joinedAudioDiscussion;
        }
        if (this.remoteUsers) {
          const student = this.remoteUsers.find(
            (ru) => ru.uid === this.participation.user.id
          );
          return !!student;
        }
        return false;
      },
      on_queue() {
        return this.getQueue.find(
          (queue) => queue.user_id === this.participation.user.id
        );
      },
      audio_video_is_enabled() {
        return this.getCurrentDiscussion.audio_discussion_is_enabled;
      },
      second_screen() {
        return this.$route.query.second_screen;
      },
    },
    methods: {
      handleOpenDetailsTurn: function() {
        if (this.turn_description !== null) {
          this.is_turn_opened = !this.is_turn_opened;
        }
      },
      openStudentAssessment() {
        if (this.second_screen) return;
        if (this.hasTeacherPermissionsInCourse)
          EventBus.$emit('openAssessmentStudent', this.participation);
      },
      determineTurnTypeIconHTML(type) {
        let icon = `<i class="fas `;
        /* let img = `<img
              class="h-4 w-5"
              src="/static/live_discussion/ld_question_icon_white.svg"
            />`; */
        switch (type) {
          case 'new_idea':
            icon += 'fa-play" ';
            break;
          case 'build_on':
            icon += 'fa-square" ';
            break;
          case 'challenge':
            icon += 'fa-circle" ';
            break;
          case 'question':
            icon += 'fa-circle-question" ';
            break;
          case 'hand_raise':
            icon += 'fa-chalkboard-user" ';
            break;
          default:
            icon = '';
        }
        if (icon) {
          icon += 'style="color: white"></i>';
          return icon;
        } /* else if (img && type === 'question') {
          return img;
        } else {
          return '';
        } */
      },
      generateTurnPhrases(turnType) {
        let title = '';
        let backgroundColor = '';
        switch (turnType) {
          case 'new_idea':
            title = this.$t('new_idea'); //'New Idea';
            backgroundColor = 'bg-primary';
            break;
          case 'build_on':
            title = this.$t('build_on'); //'Build On';
            backgroundColor = 'bg-green-700';
            break;
          case 'challenge':
            title = this.$t('challenge'); //'Challenge';
            backgroundColor = 'bg-pinky';
            break;
          case 'question':
            title = this.$t('question'); //'Question';
            backgroundColor = 'bg-darkBlue-dark';
            break;
          case 'hand_raise':
            title = this.$t('added_by_teacher'); //'By Teacher';
            backgroundColor = 'bg-orange';
            break;
          default:
            title = '';
            backgroundColor = '';
        }
        return {
          title,
          backgroundColor,
        };
      },
      encourageStudent() {
        updateTurn(this.currentTurn.id, {
          new_encourager: this.getProfile.id,
        });
      },
      showApplauseIcons() {
        const this_element = document.getElementById(
          `circle-list-${this.participation.user_id}`
        );
        const element_coordinates = this_element.getBoundingClientRect();
        const w = window.innerWidth;
        const h = window.innerHeight;

        confetti({
          particleCount: 80,
          spread: 200,
          angle: 270,
          ticks: 40,
          decay: 0.8,
          startVelocity: 10,
          origin: {
            x: (element_coordinates.x + element_coordinates.width / 2) / w,
            y: element_coordinates.y / h,
          },
        });
      },
      addToApplauseArray: throttle(
        function () {
          this.showApplauseIcons();
          updateTurn(this.currentTurn.id, {
            new_clap: this.getProfile.id,
            participation_id: this.currentTurn.participation_id,
          });
        },
        1200,
        { leading: true, trailing: false }
      ),
      addToQueue: async function (turnID) {
        EventBus.$emit('queueLoading', true);
        await this.$store
          .dispatch('enterQueue', {
            discussion_id: this.getCurrentDiscussion.id,
            hand_raise_type: 'hand_raise_type',
            user_id: this.participation.user.id,
            turn_id: turnID,
          })
          .then((res) => {
            if (res.failedReason || res.error)
              EventBus.$emit('queueLoading', false);
          })
          .catch(() => EventBus.$emit('queueLoading', false));
      },
      removeSpeaker: async function (userId) {
        EventBus.$emit('queueLoading', true);
        if (this.audio_video_is_enabled) {
          const participation = this.getCurrentDiscussion.participations.find(
            (x) => x.user_id === userId
          );
          if (participation.audio_is_enabled)
            await toggleStudentParticipationAudio(
              this.$route.params.liveDiscussionID,
              participation.id
            );
          if (participation.video_is_enabled) {
            await toggleStudentParticipationVideo(
              this.$route.params.liveDiscussionID,
              participation.id
            );
          }
        }
        await this.$store
          .dispatch('tapOut', {
            discussion_id: this.getCurrentDiscussion.id,
            user_id: userId,
          })
          .then(async (res) => {
            if (res.failedReason || res.error)
              EventBus.$emit('queueLoading', false);
          })
          .catch(() => EventBus.$emit('queueLoading', false));
      },
      leaveQueue: async function (userID, turn_id) {
        EventBus.$emit('queueLoading', true);
        await this.$store
          .dispatch('leaveQueue', {
            discussion_id: this.getCurrentDiscussion.id,
            user_id: userID,
            turn_id: turn_id,
          })
          .then((res) => {
            if (res.failedReason || res.error)
              EventBus.$emit('queueLoading', false);
          })
          .catch(() => EventBus.$emit('queueLoading', false));
      },
      async teacherRemoveStudentFromCircle(userId) {
        if (this.isTappingOut === true) return;
        this.isTappingOut = true;
        const participation = this.getCurrentDiscussion.participations.find((x) => x.user_id === userId);
        if (this.audio_video_is_enabled) {
          if (participation.audio_is_enabled)
            await toggleStudentParticipationAudio(this.$route.params.liveDiscussionID, participation.id);
          if (participation.video_is_enabled)
            await toggleStudentParticipationVideo(this.$route.params.liveDiscussionID, participation.id);
        }
        await removeStudentFromCircle(this.getCurrentDiscussion.id, userId, participation.id);
        this.is_button_queue_activate = true;
        setTimeout(() => {
          this.isTappingOut = false;
        }, 1000);
      },
      muteStudentParticipation(participation) {
        if (this.hasTeacherPermissionsInCourse || this.user_is_moderator) {
          toggleStudentParticipationAudio(
            this.$route.params.liveDiscussionID,
            participation.id
          );
        }
      },
      toggleTurnDescription() {
        if (!this.currentTurn.description) return;
        this.openTurnDescription = !this.openTurnDescription;
      },
    },
    mounted() {
      this.$i18n.locale = this.getCurrentDiscussion.language;
      this.audio_video_is_active =
        this.getCurrentDiscussion.audio_discussion_is_enabled;
      EventBus.$on('end-participation-audio-live', () => {
        this.audio_video_is_active = false;
      });
      EventBus.$on('participations_speaking', (participations_list) => {
        this.speaking_participants = participations_list;
      });
    },
    beforeDestroy() {
      EventBus.$off('end-participation-audio-live');
      EventBus.$off('participations_speaking');
    },
  });
</script>
<style lang="stylus" scoped>
  .gavel-style
    i
      transform: matrix(-1, 0, 0, 1, 0, 0)
  .pl-menu-li
    &:hover
      background-color: #72CCD7 !important;
  #pl-menu .menu-card
    margin: 0;
    background-color: black;
    opacity: 0.7
  .bottom-card
    background-color: black;
    opacity: 0.6;
  .footer-font-size
    font-size: 13px
  .max-width-name
    max-width: 50px
</style>


// WEBPACK FOOTER //
// LDDiscussionCircle.vue?24bc64d4